import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { PelicanCircle } from '../icons/icons';

type OwnDeps = {
  questionsService: QuestionsService;
};
@requires(QuestionsService.serviceName)
@customElement('before-exit-popup')
export class BeforeExitPopup extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
        .title {
          font-weight: 700;
          font-size: 4rem;
      }
     .sub-title {
       font-size: 4rem;
       font-weight: 700;
       margin-bottom: 2rem;
       line-height: 4rem;
       color: var(--c-text-sub);
     }
     .message {
       font-weight: 400;
       max-width:var(--message-max-width, 39rem);
       color: var(--c-text);
      }  
      
     svg, img{
       max-width: 26.5rem;
       max-height: 36.5rem;
    }
      `,
    ];
  };
  static get desktopStyles() {
    return [css`
      .title {
        margin-block: 4rem;
      }
    `];
  };
  static get mobileStyles() {
    return [commonPopupMobileStyle,
      css`
   .title{
       text-align:center;
       font-size:3rem
      }
      .message {
        margin-block-end:1rem;
      }
      .message h2{
        font-size:2rem;
      }
  `];
  };

  @property({ type: String })
    value: string = '';

  renderMobileLayout() {
    return html`
      <div class="">
        <div class="popup-image-container">
          ${PelicanCircle}
        </div>
       <div class="col-1">
         <h1 class="title">${t('E_Before_Exit_Title')}</h1>
       </div>
      <div class="col-3">
        <h2 class="message">${t('E_Before_Exit_Text')}</h2>
      </div>      
     </div>
    `;
  }

  renderDesktopLayout() {
    return html`
     <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2">
        <h1 class="title">${t('E_Before_Exit_Title')}</h1>  
        <h2 class="message">${t('E_Before_Exit_Text')}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}